
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mypage",
      function () {
        return require("private-next-pages/mypage/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mypage"])
      });
    }
  